module.exports = __webpack_public_path__ + "static/media/medal.65bebea8.svg";